function setIndividualProductClick (element, listType) {

	const _listType = listType;

	const trackingData = {
		event_action: 'product click',
		event_category: 'ecommerce',
		event_label: `${window.utag_data.product_sku}-${window.utag_data.product_name}`,
		event_name: 'product_click',
		product_category: window.utag_data.product_category,
		product_impression_list: window.utag_data.product_impression_list[0],
		product_action_list: window.utag_data.product_impression_list[0],
		product_impression_position: [],
		product_price: window.utag_data.product_price,
		product_name: window.utag_data.product_name,
		product_sku: window.utag_data.product_sku,
		filter_id: window.utag_data.filter_id,
		list_type: _listType,
		product_grouping: window.utag_data.product_grouping,
		sku_input_type: window.utag_data.sku_input_type
	};

	if (element && !element.dataset.hasTracking) {

		element.addEventListener('click', () => {

			if (window.utag && window.utag_data) {

				window.utag.link(trackingData);

			}

		});

		element.dataset.hasTracking = 'true';

	}

}

export default setIndividualProductClick;
